/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { ZodError, z } from 'zod';

import {
  IntercomUserCredentialsDocument,
  type IntercomUserCredentialsQuery,
  type IntercomUserCredentialsQueryVariables,
} from '@fai/friendli-suite/generated/client/graphql';
import client from '@fai/friendli-suite/shared/apollo/base-link';

const intercomUserCredentials = z
  .object({
    id: z.string(),
    icIdentityHmac: z.object({
      externalId: z.string(),
      hmac: z.string(),
    }),
    name: z.string().nullable(),
    email: z.string().email().nullable(),
  })
  .optional();

export async function getIntercomUserCredentials({ teamId }: { teamId: string }) {
  const { data } = await client.query<
    IntercomUserCredentialsQuery,
    IntercomUserCredentialsQueryVariables
  >({
    query: IntercomUserCredentialsDocument,
    variables: { teamId },
    fetchPolicy: 'network-only',
  });

  const response = intercomUserCredentials.safeParse(data?.clientSession?.user);

  if (response.success) {
    return response.data;
  }

  throw new ZodError(response.error.issues);
}
